import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

const calendarService = {
  // Get all calendar items for a group
  getCalendarItems: async (groupId, params = {}) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/groups/${groupId}/calendar-items`,
        {
          params: {
            ...params,
            _t: Date.now() // Cache buster
          },
          withCredentials: true
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching calendar items:', error);
      throw error.response?.data || error;
    }
  },

  // Get a single calendar item
  getCalendarItem: async (groupId, itemId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/groups/${groupId}/calendar-items/${itemId}`,
        {
          withCredentials: true
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching calendar item:', error);
      throw error.response?.data || error;
    }
  },

  // Create a new calendar item
  createCalendarItem: async (itemData) => {
    try {
      const { group_id, ...data } = itemData;
      const response = await axios.post(
        `${API_BASE_URL}/groups/${group_id}/calendar-items`,
        data,
        {
          withCredentials: true
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating calendar item:', error);
      throw error.response?.data || error;
    }
  },

  // Update a calendar item
  updateCalendarItem: async (itemId, itemData) => {
    try {
      const { group_id, ...data } = itemData;
      const response = await axios.put(
        `${API_BASE_URL}/groups/${group_id}/calendar-items/${itemId}`,
        data,
        {
          withCredentials: true
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating calendar item:', error);
      throw error.response?.data || error;
    }
  },

  // Delete a calendar item
  deleteCalendarItem: async (groupId, itemId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/groups/${groupId}/calendar-items/${itemId}`,
        {
          withCredentials: true
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting calendar item:', error);
      throw error.response?.data || error;
    }
  },

  // Get all calendar data (events, classes, and calendar items) for a date range
  getAllCalendarData: async (groupId, startDate, endDate) => {
    try {
      const [events, classes, calendarItems] = await Promise.all([
        axios.get(`${API_BASE_URL}/groups/${groupId}/events`, {
          params: { includeClasses: false },
          withCredentials: true
        }),
        axios.get(`${API_BASE_URL}/groups/${groupId}/classes`, {
          withCredentials: true
        }),
        calendarService.getCalendarItems(groupId, {
          start_date: startDate?.toISOString(),
          end_date: endDate?.toISOString()
        })
      ]);

      return {
        events: events.data || [],
        classes: classes.data || [],
        calendarItems: calendarItems || []
      };
    } catch (error) {
      console.error('Error fetching all calendar data:', error);
      throw error.response?.data || error;
    }
  }
};

export default calendarService;
